var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BRow, BCol, BAlert } from 'bootstrap-vue';
let FrameExtras = class FrameExtras extends Vue {
    artworkDimensions;
    rebateDimensions;
    mountBorders;
    mouldingWidth;
    hasMount;
    get apertureDimensions() {
        return {
            width: this.artworkDimensions.width - 6,
            length: this.artworkDimensions.length - 6
        };
    }
    get glassDimensions() {
        if (this.hasMount) {
            return {
                width: this.artworkDimensions.width - 6 + (this.mountBorders.left + this.mountBorders.right),
                length: this.artworkDimensions.length - 6 + (this.mountBorders.top + this.mountBorders.bottom),
            };
        }
        return {
            width: this.artworkDimensions.width,
            length: this.artworkDimensions.length
        };
    }
    get visibleInternalDimensions() {
        return {
            width: this.glassDimensions.width - 6,
            length: this.glassDimensions.length - 6
        };
    }
};
__decorate([
    Prop(Object)
], FrameExtras.prototype, "artworkDimensions", void 0);
__decorate([
    Prop(Object)
], FrameExtras.prototype, "rebateDimensions", void 0);
__decorate([
    Prop(Object)
], FrameExtras.prototype, "mountBorders", void 0);
__decorate([
    Prop(Number)
], FrameExtras.prototype, "mouldingWidth", void 0);
__decorate([
    Prop(Boolean)
], FrameExtras.prototype, "hasMount", void 0);
FrameExtras = __decorate([
    Component({
        components: {
            BRow, BCol, BAlert
        }
    })
], FrameExtras);
export default FrameExtras;
